module.exports = __webpack_public_path__ + "static/smpulledapart-c52d2b80a635d8a3e7d204d781e25eb4.png";